// extracted by mini-css-extract-plugin
export default {"galleryItem":"GalleryItem_galleryItem__o1gdL","wrapperImg":"GalleryItem_wrapperImg__xZWiK","imgSub":"GalleryItem_imgSub__qHrgX","galleryImg":"GalleryItem_galleryImg__u-S6a"};